import React, { FC } from 'react'
import { EuiHeader } from '@elastic/eui'

import CollapsibleNav from './CollapsibleNav'
import HeaderLogo from './HeaderLogo'
// import { SecurityNavControl } from '../auth/SecurityNavControl';
import { useRouterLinkProps } from './Header.utils'
import AuthButton from '../../../utils/auth/AuthButton'
import { EuiHeaderText } from './EuiHeaderText'
import LanguageSelect from './LanguageSelect'

export interface Props {}

const HeaderWithMenu: FC<Props> = (props) => {
  const [href, onClick] = useRouterLinkProps('/')

  // @ts-ignore
  const REACT_APP_LOGO_URL = window.REACT_APP_LOGO_URL
  // @ts-ignore
  const REACT_APP_BRAND_NAME = window.REACT_APP_BRAND_NAME

  const headerLogo = (
    <HeaderLogo
      // @ts-ignore
      src={`${process.env.PUBLIC_URL}/static/brand/SCAIVIEW.svg`}
      // @ts-ignore
      href={href}
      onClick={onClick}
      aria-label="Application logo"
    />
  )

  let items
  if (REACT_APP_LOGO_URL || REACT_APP_BRAND_NAME)
    items = [
      <CollapsibleNav />,
      <EuiHeaderText
        iconSrc={REACT_APP_LOGO_URL}
        // @ts-ignore
        href={href}
        // @ts-ignore
        onClick={onClick}
      >
        {REACT_APP_BRAND_NAME}
      </EuiHeaderText>,
      headerLogo,
    ]
  else items = [<CollapsibleNav />, headerLogo]

  // @ts-ignore
  return (
    <EuiHeader
      // position="fixed"
      sections={[
        {
          items: items,
          borders: 'right',
        },
        {
          items: [
            <LanguageSelect />,
            <AuthButton />,
            // <SecurityNavControl />
          ],
        },
      ]}
    />
  )
}

export default HeaderWithMenu
